import { WprDI_Control } from '../../wpr-framework/view/di/WprDI_Control';
import { WprControlInfo } from '../../wpr-framework/view/control/WprControlInfo';
import { WprViewMode } from '../../wpr-framework/view/deco/WprViewMode';
import { WprModel } from '../../wpr-framework/view/deco/WprModel';
import { WprDI_ScopeModel } from '../../wpr-framework/view/di/WprDI_ScopeModel';
import { ContractorInfo } from '../../models/ContractorInfo';
import { TravelerInfo } from '../../models/TravelerInfo';
import { LoginInfo } from '../../models/LoginInfo';
import { PersonalInfoMode } from './mode/PersonalInfoMode';
import { WprListData } from '../../wpr-framework/view/deco/WprListData';
import { PersonalInfoListMode } from './mode/PersonalInfoListMode';
import { WprKeyValue } from '../../wpr-framework/model/WprKeyValue';
import { WprValidError } from '../../wpr-framework/view/validation/WprValidError';
import { ScrollPositionInfo } from '../../models/ScrollPositionInfo';
import { SecondScopeInfo } from '../../scope/SecondScopeInfo';
import { WprRowInfo } from '../../wpr-framework/component/props/WprRowInfo';
import { AuthConfirmRequest } from '../../service/service-models/auth-confirm/AuthConfirmRequest';
import { MailAuthService } from '../../service/MailAuthService';
import { BaseWindowViewScope } from '../base/BaseWindowViewScope';
import { PlanByTravelWLService } from '../../service/PlanByTravelWLService';
import { CollateralDisplayRequest } from '../../service/service-models/collateral-display/CollateralDisplayRequest';
import { ContractNoticeRequest } from '../../service/service-models/contract-notice/ContractNoticeReqesut';
import { ContractNoticeInfo } from '../../service/models/contract-notice/contract-notice-info';
import { ContractNoticeService } from '../../service/ContractNoticeService';
import { OthersInfo } from '../../models/OthersInfo';
import { BasicInfo } from '../../models/BasicInfo';
import { RiskFactorInfo } from '../../service/models/risk-factor/risk-factor-info';
import { SelectPlanInfo } from '../../service/models/select-plan/select-plan-info';
import { CollateralInfo } from '../../models/CollateralInfo';
import { SpecialProvision } from '../../models/SpecialProvision';
import { PaymentInfo } from '../../service/models/payment/payment-info';
import { PersonalInfoAddressMode } from './mode/PersonalInfoAddressMode';
import { WlMasterDataInfo } from '../../service/models/wl-master/wl-master-data-info';
import { CollateralDisplayResult } from '../../service/service-models/collateral-display/CollateralDisplayResult';
import { ContractNoticeResult } from '../../service/service-models/contract-notice/ContractNoticeResult';
import { TestService } from '../../service/TestService';
import { AddressRequest } from '../../service/service-models/test/address/AddressRequest';
import { AddressInfo } from '../../service/service-models/test/address/AddressInfo';
import { AuthConfirmResult } from '../../service/service-models/auth-confirm/AuthConfirmResult';
import { WprDI_GlobalScopeModel } from '../../wpr-framework/view/di/WprDI_GlobalScopeModel';
import { PolicyHolderInfo } from '../../service/models/policy-holder/policy-holder-info';
import { InsuredInfo } from '../../service/models/insured/insured-info';
import { AuthMailInfo } from '../../service/models/auth-mail/auth-mail-info';
import { AddressService } from '../../service/AddressService';
import { AddressResult } from '../../service/service-models/test/address/AddressResult';
import { PolicyContractInfo } from '../../service/models/policy-contract/policy-contract-info';
import { AddressSelectInfo } from '../../service/service-models/test/address/AddressSelectInfo';


/**
 * 個人情報登録ビュー情報
 */
export class PersonalInfoComponentView extends BaseWindowViewScope<SecondScopeInfo> {
	// private 変数　----------------------------------------------------------------------------------------
	private m_HttpStatus: boolean 					= false;	// 住所検索APIのHTTPステータス
	private m_ClearValueControl	: WprControlInfo 	= null;		// 値クリアコントロール
	public readonly EXTRA_COLLKEY_OTA: string 		= 'AT23';		// 	追加保障キー（OTA）
	public readonly ADULT_AGE_ERROR: string 		= 'お申込み時点で、18歳未満の方はお申込できません';	// 成人判定エラー
	// ------------------------------------------------------------------------------------------------------

	// モデル -----------------------------------------------------------------------------------------------
	@WprDI_GlobalScopeModel('product')
	private m_ProductCode: string 							= null;	// 商品コード
	@WprDI_GlobalScopeModel('agentcode')
	private m_Agency: string 								= null;	// 代理店コード
	@WprDI_ScopeModel('BasicInfo')
	@WprModel('BasicInfo')
	private m_BasicInfo: BasicInfo 							= null; // 基本情報
	@WprDI_ScopeModel('ContractorInfo')
	@WprModel('ContractorInfo')
	private m_ContractorInfo: ContractorInfo 				= null; // 契約者（申込者）情報
	@WprDI_ScopeModel('TravelerInfo')
	@WprListData('TravelerInfo')
	@WprModel('TravelerInfo')
	private m_TravelerListInfo: TravelerInfo[] 				= null; // 旅行者（被保険者）リスト情報
	@WprDI_ScopeModel('LoginInfo')
	@WprModel('LoginInfo')
	private m_LoginInfo: LoginInfo 	 						= null; // ログイン情報
	@WprDI_ScopeModel('ScrollPositionInfo')
	@WprModel('ScrollPositionInfo')
	private m_ScrollPositionInfo: ScrollPositionInfo 	 	= null; // スクロール位置情報
	@WprDI_ScopeModel('PolicyHolderInfo')
	@WprModel('PolicyHolderInfo')
	private m_PolicyHolderInfo: PolicyHolderInfo 	 		= null; // 契約者情報（サービス）
	@WprDI_ScopeModel('InsuredInfoList')
	@WprModel('InsuredInfoList')
	private m_InsuredInfoList: InsuredInfo[]				= null; // 旅行者リスト情報（サービス）
	@WprDI_ScopeModel('ContractNoticeInfo')
	@WprListData('ContractNoticeInfo')
	@WprModel('ContractNoticeInfo')
	private m_ContractNoticeList: ContractNoticeInfo[] 		= null; // 告知事項情報
	@WprDI_ScopeModel('OthersInfo')
	@WprModel('OthersInfo')
	private m_OthersInfo: OthersInfo 						= null; // その他情報
	@WprModel('WlMasterDataInfo')
	private m_MasterData: WlMasterDataInfo 					= null;	// マスタデータ情報
	@WprListData('CollateralInfo')
	@WprModel('CollateralInfo')
	private m_Collaterals: CollateralInfo[]					= null; // 補償表示情報
	@WprDI_ScopeModel('RiskFactorInfo')
	private m_RiskFactorInfo: RiskFactorInfo 				= null;	// リスクファクター情報
	@WprDI_ScopeModel('SelectPlanInfo')
	private m_SelectPlanInfo: SelectPlanInfo 				= null;	// 選択プラン情報
	@WprDI_ScopeModel('AuthMailInfo')
	private m_AuthMailInfo: AuthMailInfo 				= null;	// 選択プラン情報
	@WprDI_ScopeModel('SpecialProvision')
	private m_SpecialProvision: SpecialProvision 			= null; // 特約・約款情報
	// WRQ2083 住所検索のエラー修正 S
	// @WprListData('AddressList')
	// @WprModel('AddressList')
	// private m_AddressInfoList: AddressInfo[] 				= null; // 複数住所情報
	@WprListData('AddressSelectList')
	@WprModel('AddressSelectList')
	private m_AddressSelectInfoList: AddressSelectInfo[] 				= null; // 複数住所情報
	@WprDI_GlobalScopeModel('AuthMailId')
	private m_AuthMailId: string							= null;
	// WRQ2083 住所検索のエラー修正 E
	// ------------------------------------------------------------------------------------------------------

	// DI情報  ----------------------------------------------------------------------------------------------
	@WprDI_Control
	private m_YearContractor: WprControlInfo 	= null; // 年（契約者）
	@WprDI_Control
	private m_MonthContractor: WprControlInfo 	= null; // 月（契約者）
	@WprDI_Control
	private m_DateContractor: WprControlInfo 	= null; // 日（契約者）
	@WprDI_Control
	private m_LoginPass: WprControlInfo 		= null; // パスワード
	@WprDI_Control
	private m_LoginPassAgain: WprControlInfo 	= null; // 確認用パスワード
	@WprDI_Control
	private m_PostalCode: WprControlInfo 		= null; // 郵便番号
	@WprDI_Control
	private m_RadioSelect: WprControlInfo 		= null; // 住所選択
	@WprDI_Control
	private m_Prefecture: WprControlInfo 		= null; // 都道府県
	@WprDI_Control
	private m_Address1: WprControlInfo 			= null; // 住所１
	// ------------------------------------------------------------------------------------------------------

	// サブビュー/モード  ------------------------------------------------------------------------------------
	@WprViewMode
	private m_ViewMode 			= new PersonalInfoMode(); 		// 入力状態管理モード
	@WprViewMode
	private m_ViewListMode 		= new PersonalInfoListMode(); 		// リストモード
	@WprViewMode
	private m_ViewAddressMode 	= new PersonalInfoAddressMode(); 	// 住所検索モード
	// ------------------------------------------------------------------------------------------------------

	// サービス ----------------------------------------------------------------------------------------------
	private m_MailAuthService: MailAuthService 				= new MailAuthService();		//　認証メールサービス
	private m_ContractNoticeService: ContractNoticeService 	= new ContractNoticeService();	//　告知事項サービス
	private m_PlanByTravelWLService: PlanByTravelWLService 	= new PlanByTravelWLService();	//　プランサーチサービス
	private m_TestService: TestService						= new TestService();			//　テストサービス（仮の住所検索API）
	private m_AddressService: AddressService				= new AddressService();			//　住所検索サービス
	// -------------------------------------------------------------------------------------------------------
	
	// コンストラクタ  -----------------------------------------------------------------------------------------
	public constructor() {
		super('step5_personal-information');
	}
	// -------------------------------------------------------------------------------------------------------

	// override メソッド  -------------------------------------------------------------------------------------
	/**
	 * コントロール定義設定
	 */
	public onRegisterConfig(): void {
		// 契約者（申込者）			
		this.addConfig('lastNameContractor', '姓（漢字・平仮名・カタカナ）', 'ContractorInfo', { bindName: 'lastName', maxLength: 14, validation: '全角', hissu: true, noEditClass: 'first', errorClass: 'error' });
		this.addConfig('firstNameContractor', '名（漢字・平仮名・カタカナ）', 'ContractorInfo', { bindName: 'firstName', maxLength: 14, validation: '全角', hissu: true, noEditClass: 'first', errorClass: 'error' });
		this.addConfig('romanLastNameContractor', '姓（ローマ字）', 'ContractorInfo', {	bindName: 'romanLastName', maxLength: 14, hissu: true, validation: '半角英字', noEditClass: 'first', errorClass: 'error' });
		this.addConfig('romanFirstNameContractor', '名（ローマ字）', 'ContractorInfo', { bindName: 'romanFirstName', maxLength: 14, hissu: true, validation: '半角英字', noEditClass: 'first', errorClass: 'error' });
		this.addConfig('yearContractor', '年', 'ContractorInfo', { bindName: 'year', maxLength: 4, hissu: true, noEditClass: 'first', errorClass: 'error' });
		this.addConfig('monthContractor', '月', 'ContractorInfo', { bindName: 'month', maxLength: 2, hissu: true, noEditClass: 'first', errorClass: 'error' });
		this.addConfig('dateContractor', '日', 'ContractorInfo', { bindName: 'date', maxLength: 2, hissu: true, noEditClass: 'first', errorClass: 'error' });
		this.addConfig('genderContractor', '性別', 'ContractorInfo', { bindName: 'gender', hissu: true, noEditClass: 'first', errorClass: 'error' });
		this.addConfig('postalCode', '郵便番号', 'ContractorInfo', { minLength: 7, maxLength: 7, hissu: true, noEditClass: 'first', errorClass: 'error' });
		this.addConfig('prefecture', '都道府県', 'ContractorInfo', { bindName: 'prefecture', maxLength: 4, hissu: true, noEditClass: 'first', errorClass: 'error' });
		this.addConfig('address1', '住所1', 'ContractorInfo', { bindName: 'address1', maxLength: 64, hissu: true, validation: '全角', noEditClass: 'first', errorClass: 'error' });
		this.addConfig('address2', '住所2', 'ContractorInfo', { maxLength: 64, validation: '全角', noEditClass: 'first', errorClass: 'error' });
		this.addConfig('tel', '電話番号', 'ContractorInfo', { minLength: 9, maxLength: 11, hissu: true, noEditClass: 'first', errorClass: 'error' });
		// 旅行者（被保険者）
		this.addListConfig('romanLastNameTraveler', '姓（ローマ字）', 'TravelerInfo', { bindName: 'romanLastName', maxLength: 14, hissu: true, validation: '半角英字', action: 'copy', noEditClass: 'first', errorClass: 'error' });
		this.addListConfig('romanFirstNameTraveler', '名（ローマ字）', 'TravelerInfo', { bindName: 'romanFirstName', maxLength: 14, hissu: true, validation: '半角英字', action: 'copy', noEditClass: 'first', errorClass: 'error' });
		this.addListConfig('yearTraveler', '年', 'TravelerInfo', { bindName: 'year', maxLength: 4, hissu: true, action: 'copy', noEditClass: 'first', errorClass: 'error' });
		this.addListConfig('monthTraveler', '月', 'TravelerInfo', { bindName: 'month', maxLength: 2, hissu: true, action: 'copy', noEditClass: 'first', errorClass: 'error' });
		this.addListConfig('dateTraveler', '日', 'TravelerInfo', { bindName: 'date', maxLength: 2, hissu: true, action: 'copy', noEditClass: 'first', errorClass: 'error' });
		this.addListConfig('genderTraveler', '性別', 'TravelerInfo', { bindName: 'gender', hissu: true, action: 'copy', noEditClass: 'first', errorClass: 'error' });
		// ログイン情報
		this.addConfig('loginPass', 'パスワード', 'LoginInfo', { minLength: 8, hissu: true, validation: 'パスワード使用可能文字,パスワード組み合わせ', noEditClass: 'first', errorClass: 'error' });
		this.addConfig('loginPassAgain', '確認用のパスワード', 'LoginInfo', { minLength: 8, hissu: true, validation: 'パスワード使用可能文字,パスワード組み合わせ', noEditClass: 'first', errorClass: 'error' });
		// モーダル用
		this.addConfig('radioSelect', '住所選択', null);
		this.addConfig('closebtn', '閉じるボタン', null);
		// WRQ2083 住所検索のエラー修正 S
		// this.addListConfig('adrsInfo', '住所情報', 'AddressList', { bindName: 'prefecture' });
		this.addListConfig('adrsInfo', '住所情報', 'AddressSelectList', { bindName: 'address' });
		// WRQ2083 住所検索のエラー修正 E
	}

	/**
	 * アクション登録
	 */
	public onRegisterAction(): void {
		this.addBlurAction('lastNameContractor', null, true);
		this.addBlurAction('firstNameContractor', null, true);
		this.addBlurAction('romanLastNameContractor', null, true);
		this.addBlurAction('romanFirstNameContractor', null, true);
		this.addBlurAction('yearContractor', null, true);
		this.addBlurAction('monthContractor', null, true);
		this.addBlurAction('dateContractor', null, true);
		this.addBlurAction('genderContractor', null, true);
		this.addBlurAction('postalCode', this.onSearchAdrs, true, true);
		this.addBlurAction('prefecture', null, true);
		this.addBlurAction('address1', null, true);
		this.addBlurAction('address2', null, true);
		this.addBlurAction('tel', null, true);
		this.addListBlurAction('romanLastNameTraveler', 'TravelerInfo', null, true);
		this.addListBlurAction('romanFirstNameTraveler', 'TravelerInfo', null, true);
		this.addListBlurAction('yearTraveler', 'TravelerInfo', null, true);
		this.addListBlurAction('monthTraveler', 'TravelerInfo', null, true);
		this.addListBlurAction('dateTraveler', 'TravelerInfo', null, true);
		this.addListBlurAction('genderTraveler', 'TravelerInfo', null, true);
		this.addBlurAction('loginPass', null, true);
		this.addBlurAction('loginPassAgain', null, true);
		this.addListAction('copy', 'TravelerInfo', this.onCopy, false);
		this.addAction('selectbtn', this.onSelect);
		this.addAction('closebtn', this.onClose);
		this.addAction('toNext', this.onNext, false, true);
	}

	/**
	 * バリデーションエラーメッセージ通知
	 * @param name コントロール名
	 * @param rowIndex 行数(Listの場合)
	 * @param validatorName バリデーション名
	 * @param msg エラーメッセージ
	 * @returns エラーメッセージ（変更する場合に指定する、メッセージを使用しない場合は、nullを返す）
	 */
	public onInvalidMessage(name: string, rowIndex: number, validatorName: string, msg: string): string {
		if (name === 'postalCode') {
			if (validatorName === '最小文字数')
				return '郵便番号を7桁で入力してください';
		}
		if (name === 'tel') {
			if (validatorName === '最小文字数' || validatorName === '最大文字数')
				return '数字のみで9～11桁で入力してください';
		}
		if (name === 'loginPass') {
			if (validatorName === '最小文字数')
				return 'パスワードは8文字以上で設定してください';
		}
		if (name === 'loginPassAgain') {
			if (validatorName === '最小文字数')
				return 'パスワードは8文字以上で設定してください';
		}
		return msg;
	}

	/**
	 * 入力チェック（独自のValidationを実施する場合に使用する）
	 *   エラー追加例：WprValidError.addError('エラーメッセージ');
	 * 				  this.setControlError('control', 'error');
	 * @param actionName アクション名
	 * @param validError バリデーションエラー情報
	 */
	protected onValid(actionName: string, validError: WprValidError, row?: any): void {
		if (this.m_LoginPass.value && this.m_LoginPassAgain.value && (actionName === 'loginPassAgain' || actionName === 'loginPass')) {
			if ((this.m_LoginPass.value && this.m_LoginPassAgain.value) && (this.m_LoginPass.value !== this.m_LoginPassAgain.value))
				this.setControlError('loginPassAgain', 'パスワードが一致しません');
			else
				this.clearControlError('loginPassAgain', 'パスワードが一致しません');
		}
		if (actionName === 'dateContractor' || actionName === 'monthContractor' || actionName === 'yearContractor') {
			// WRQ-3106_旅行保険 引受年齢満18歳対応 START
			this.clearControlError('yearContractor', this.ADULT_AGE_ERROR);
			this.clearControlError('monthContractor', this.ADULT_AGE_ERROR);
			this.clearControlError('dateContractor', this.ADULT_AGE_ERROR);
			// this.clearControlError('yearContractor', 'お申込み時点で、20歳未満の方はお申込できません');
			// this.clearControlError('monthContractor', 'お申込み時点で、20歳未満の方はお申込できません');
			// this.clearControlError('dateContractor', 'お申込み時点で、20歳未満の方はお申込できません');
			// WRQ-3106_旅行保険 引受年齢満18歳対応 END
			if (this.m_YearContractor.value && this.m_MonthContractor.value && this.m_DateContractor.value) {
				// let today = new Date();
				let today = new Date(this.m_AuthMailInfo.applicationDate);
				// WRQ-3106_旅行保険 引受年齢満18歳対応 START
				if (this.calculateAge(today.getFullYear(), (today.getMonth() + 1), today.getDate(), this.m_YearContractor.value, this.m_MonthContractor.value, this.m_DateContractor.value) < 18) {
					this.setControlError('yearContractor', this.ADULT_AGE_ERROR);
					this.setControlError('monthContractor', this.ADULT_AGE_ERROR);
					this.setControlError('dateContractor', this.ADULT_AGE_ERROR);
					// if (this.calculateAge(today.getFullYear(), (today.getMonth() + 1), today.getDate(), this.m_YearContractor.value, this.m_MonthContractor.value, this.m_DateContractor.value) < 20) {
					// this.setControlError('yearContractor', 'お申込み時点で、20歳未満の方はお申込できません');
					// this.setControlError('monthContractor', 'お申込み時点で、20歳未満の方はお申込できません');
					// this.setControlError('dateContractor', 'お申込み時点で、20歳未満の方はお申込できません');
				}
				// WRQ-3106_旅行保険 引受年齢満18歳対応 END
			}
		}
		if (actionName === 'dateTraveler' || actionName === 'monthTraveler' || actionName === 'yearTraveler') {
			const yearValue = this.getListControlValue('yearTraveler', 'TravelerInfo', row);
			const monthValue = this.getListControlValue('monthTraveler', 'TravelerInfo', row);
			const dateValue = this.getListControlValue('dateTraveler', 'TravelerInfo', row);
			const index = this.getListControl('yearTraveler', 'TravelerInfo', row).rowIndex;
			this.clearControlError('yearTraveler', null, 'TravelerInfo', index);
			this.clearControlError('monthTraveler', null, 'TravelerInfo', index);
			this.clearControlError('dateTraveler', null, 'TravelerInfo', index);
			if (yearValue && monthValue && dateValue) {
				let date = this.m_RiskFactorInfo.startDate;
				let splitedDate = this.splitDate(date);
				// WRQ-3804_【旅行保険】ホワイトラベル 海外旅行保険プランの引受年齢チェック変更 START
				const age = this.calculateAge(splitedDate[0], splitedDate[1], splitedDate[2], yearValue, monthValue, dateValue);
				const planCode = this.m_SelectPlanInfo.planCode;
				if (this.m_RiskFactorInfo.companyProductCode === 'OTA'){
					// プレミアムプラン かつ 70歳以上の時
					// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 START
					// if ((planCode === 'WL2' || planCode === 'WL4') && age > 69){
					if ((planCode === 'WL2' || planCode === 'WL4' || planCode === 'WH3' || planCode === 'WH6') && age > 69){
					// WRQ-4142_【旅行保険】阪急交通社 ホワイトラベル専用プラン追加 END
						this.setControlError('yearTraveler', '保険始期日時点の年齢が満70歳以上の方はご加入できません。', 'TravelerInfo', index);
						this.setControlError('monthTraveler', '保険始期日時点の年齢が満70歳以上の方はご加入できません。', 'TravelerInfo', index);
						this.setControlError('dateTraveler', '保険始期日時点の年齢が満70歳以上の方はご加入できません。', 'TravelerInfo', index);
					}
					// プレミアムプラン以外のプラン かつ 80歳以上の時
					else if (age > 79) {
						this.setControlError('yearTraveler', '保険始期日時点の年齢が満80歳以上の方はご加入できません。', 'TravelerInfo', index);
						this.setControlError('monthTraveler', '保険始期日時点の年齢が満80歳以上の方はご加入できません。', 'TravelerInfo', index);
						this.setControlError('dateTraveler', '保険始期日時点の年齢が満80歳以上の方はご加入できません。', 'TravelerInfo', index);
					}
				}
				else if (this.m_RiskFactorInfo.companyProductCode === 'DTP' && age > 80){
					this.setControlError('yearTraveler', '保険始期日時点の年齢が満81歳以上の方はご加入できません。', 'TravelerInfo', index);
					this.setControlError('monthTraveler', '保険始期日時点の年齢が満81歳以上の方はご加入できません。', 'TravelerInfo', index);
					this.setControlError('dateTraveler', '保険始期日時点の年齢が満81歳以上の方はご加入できません。', 'TravelerInfo', index);
				}
				// if (this.calculateAge(splitedDate[0], splitedDate[1], splitedDate[2], yearValue, monthValue, dateValue) > 69 && this.m_RiskFactorInfo.companyProductCode === 'OTA'){
				// 	this.setControlError('yearTraveler', '保険始期時点の年齢が70歳以上の方はご加入できません', 'TravelerInfo', index);
				// 	this.setControlError('monthTraveler', '保険始期時点の年齢が70歳以上の方はご加入できません', 'TravelerInfo', index);
				// 	this.setControlError('dateTraveler', '保険始期時点の年齢が70歳以上の方はご加入できません', 'TravelerInfo', index);
				// }
				// else if (this.calculateAge(splitedDate[0], splitedDate[1], splitedDate[2], yearValue, monthValue, dateValue) > 80 && this.m_RiskFactorInfo.companyProductCode === 'DTP'){
				// 	this.setControlError('yearTraveler', '保険始期時点の年齢が81歳以上の方はご加入できません', 'TravelerInfo', index);
				// 	this.setControlError('monthTraveler', '保険始期時点の年齢が81歳以上の方はご加入できません', 'TravelerInfo', index);
				// 	this.setControlError('dateTraveler', '保険始期時点の年齢が81歳以上の方はご加入できません', 'TravelerInfo', index);
				// }
				// WRQ-3804_【旅行保険】ホワイトラベル 海外旅行保険プランの引受年齢チェック変更 END
			}
		}
	}

	/**
	 * 値変更通知
	 * @param name 名前
	 * @param value 値
	 * @returns falseの場合、変更を取り消す
	 */
	public onChangeValue(name: string, value: any): boolean {
		if (name === 'yearContractor' || name === 'monthContractor') {
			this.m_DateContractor.resetValueMap();
		}
		return true;
	}

	/**
	* リスト値変更通知
	* @param name 名前
	* @param row 行データ
	* @param value 値
	* @returns falseの場合、変更を取り消す
	*/
	public onChangeListValue(name: string, row: any, value: any): boolean {
		if (name === 'yearTraveler' || name === 'monthTraveler') {
			const dateControl = this.getListControl('dateTraveler', 'TravelerInfo', row);
			dateControl.resetValueMap();
		}
		else if (name === 'genderTraveler') {
			this.checkValidate(name, false, true, true, row);
			this.updateMode();
		}
		return true;
	}

	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		super.onShowView();
		// window.setTimeout(this.scroll.bind(this), 10);
		this.m_HttpStatus = true;
		if (this.m_ContractorInfo != null || this.m_TravelerListInfo != null) {
			this.setListData('TravelerInfo', this.m_TravelerListInfo);
			return;
		}
		const req: AuthConfirmRequest = new AuthConfirmRequest();
		// URLからセットされた認証メールIDを取得
		let authMailId = this.FW.getUrlParam('id');
		if (!authMailId)
			authMailId = this.m_AuthMailId;
		this.setGlobalScopeModel('AuthMailId', authMailId);
		req.authMailId = authMailId;
		this.setGlobalScopeModel('location', '/step1_riskfactor');
		
		// if (!req.authMailId)
		// 	req.authMailId = 'MTAxODQxNzY5MzcyMDAw';
		this.m_MailAuthService.mailAuthentication(this, req, result => {
			this.setGlobalScopeModel('location', '/step5_personal-information');
			this.setGlobalScopeModel('agentcode',	result.authMailInfo.riskFactorInfo.agentCode);
			this.setGlobalScopeModel('product', 	result.authMailInfo.riskFactorInfo.companyProductCode);
			this.setGlobalMode('agentcode',	result.authMailInfo.riskFactorInfo.agentCode);
			this.setGlobalMode('product', 	result.authMailInfo.riskFactorInfo.companyProductCode);
			this.setInfoForView(result);
			this.setScopeModel('AuthMailInfo', 		this.m_AuthMailInfo);
			this.setScopeModel('SelectPlanInfo', 	this.m_SelectPlanInfo);
			this.setScopeModel('RiskFactorInfo',	this.m_RiskFactorInfo);
			this.setScopeModel('BasicInfo', 		this.m_BasicInfo);
			this.setScopeModel('ContractorInfo', 	this.m_ContractorInfo);
			this.setScopeModel('TravelerInfo', 		this.m_TravelerListInfo);
			this.setListData('TravelerInfo', 		this.m_TravelerListInfo);
			// this.onUtagView();
			this.refreshView();
			if (this.onUtagView2() == false) {
				const idList: string[] = [];
				idList.push('#id-l-name-c');
				idList.push('#id-f-name-c');
				idList.push('#id-rl-name-c');
				idList.push('#id-rf-name-c');
				idList.push('#id-post-code');
				idList.push('#id-address1');
				idList.push('#id-address2');
				idList.push('#id-tel');
				idList.push('#id-pass');
				idList.push('#id-pass-again');
				for (let i: number = 0; i < this.m_TravelerListInfo.length; i++) {
					idList.push('#id-rl-name-t' + i);
					idList.push('#id-rf-name-t' + i);
				}
				this.onUtagViewWithEventOff(idList);
			}
			else {
				$('#id-l-name-c').off('click');
				$('#id-f-name-c').off('click');
				$('#id-rl-name-c').off('click');
				$('#id-rf-name-c').off('click');
				$('#id-post-code').off('click');
				$('#id-address1').off('click');
				$('#id-address2').off('click');
				$('#id-tel').off('click');
				$('#id-pass').off('click');
				$('#id-pass-again').off('click');
				for (let i: number = 0; i < this.m_TravelerListInfo.length; i++) {
					$('#id-rl-name-t' + i).off('click');
					$('#id-rf-name-t' + i).off('click');
				}
			}
		});
	}

	/**
	 * ValueMap再設定処理
	 * @param name コントロール名
	 * @param id ValueMapID
	 * @list ValueMapのKey-Valueリスト
	 * @returns 再設定したKey-Valueリスト
	 */
	public onResetValueMap(name: string, id: string, list: WprKeyValue[]): WprKeyValue[] {
		if (name === 'dateContractor') {
			const vm = this.changeDateValueMap(this.m_YearContractor.value, this.m_MonthContractor.value, list);
			if (this.m_DateContractor.value > vm.length) {
				this.m_ClearValueControl = this.getControlInfo('dateContractor');
				window.setTimeout(this.onClearValue.bind(this), 10);
			}
			return vm;
		}
		return list;
	}

	/**
	 * ValueMap再設定処理(リスト用)
	 * @param name コントロール名
	 * @param id ValueMapID
	 * @param row 行データ
	 * @list ValueMapのKey-Valueリスト
	 * @returns 再設定したKey-Valueリスト
	 */
	public onResetListValueMap(name: string, id: string, row: WprRowInfo, list: WprKeyValue[]): WprKeyValue[] {
		if (name === 'dateTraveler') {
			const yearValue = this.getListControlValue('yearTraveler', row.listName, row.rowData);
			const monthValue = this.getListControlValue('monthTraveler', row.listName, row.rowData);
			const dayValue = this.getListControlValue('dateTraveler', row.listName, row.rowData);
			const vm = this.changeDateValueMap(yearValue, monthValue, list);
			if (dayValue > vm.length) {
				this.m_ClearValueControl = this.getListControl('dateTraveler', row.listName, row.rowData);
				window.setTimeout(this.onClearValue.bind(this), 10);
			}
			return vm;
		}
		return list;
	}

	/**
	 * ロストフォーカス通知
	 * @param name コントロール名称
	 * @param value コントロール値
	 * @returns コントロール値（コントロール値を変更しない場合は、valueをそのまま返す）
	 */
	public onBlur(name: string, value: any): any {
		if (name === 'romanLastNameContractor' || name === 'romanFirstNameContractor' ||
			name === 'romanLastNameTraveler' || name === 'romanFirstNameTraveler') {
			return value.replace(/[Ａ-Ｚａ-ｚ０-９＠＿－．]/g, function (match) {
				return String.fromCharCode(match.charCodeAt(0) - 0xFEE0);
			});
		}
		if (name === 'address1' || name === 'address2') {
			return this.convertToZenkaku(value);
		}
		if (name === 'tel' || name === 'postalCode') {
			let str = value.replace(/[^0-9０-９]/g, '');
			return str.replace(/[０-９]/g, function (match) {
				return String.fromCharCode(match.charCodeAt(0) - 0xFEE0);
			});
		}
		return value;
	}

	/**
	 * Tealium Utag View　追加処理
	 */
	public onExtraUtagView(utagView: any): void {
		if(this.m_RiskFactorInfo.companyProductCode !== null && this.m_SelectPlanInfo.planCode !== null) {
			utagView.quote_prev_expiry_date 	= this.m_RiskFactorInfo.startDate;
			utagView.quote_expiry_date 			= this.m_RiskFactorInfo.endDate;
			utagView.quote_amt 					= this.m_SelectPlanInfo.totalPremium;
			utagView.quote_id 					= this.FW.getUrlParam('id');
			utagView.endorser 					= this.m_Agency;
			utagView.plancode					= this.m_SelectPlanInfo.planCode;
			utagView.country 					= this.m_RiskFactorInfo.destinationCountryCode;
			utagView.number_of_parson 			= this.m_RiskFactorInfo.numberOfInsured;
			utagView.purpose 					= this.m_RiskFactorInfo.purposeCode;
		}
	}

	/**
	 * 商品コード取得
	 */
	public get productCode(): string { 
		return this.m_ProductCode; 
	}
	// --------------------------------------------------------------------------

	// アクション  ---------------------------------------------------------------
	/**
	 * 住所検索API呼び出し処理
	 * @param param 
	 */
	public onSearchAdrs(param: any): void {
		let req: AddressRequest = new AddressRequest();
		req.postcode = this.m_PostalCode.value;
		// this.m_TestService.searchAdrs(this, req, (result) => {
		this.m_AddressService.searchAdrs(this, req, (result) => {
			if (result === null) {
				this.m_HttpStatus = false;
			}
			else {
				if (result.status === undefined || result.status === null) {
					this.m_HttpStatus = false;
				}
				else {
					let resStatus = JSON.stringify(result.status);
					if (resStatus !== '200') {
						this.m_HttpStatus = false;
					}
					else {
						if (result.data === undefined || result.data === null) {
							this.m_HttpStatus = false;
						}
						else {
							let resJson = JSON.stringify(result.data);
							const convRes: AddressResult = JSON.parse(resJson);
							this.m_ContractorInfo.postalCode 	= this.m_PostalCode.value;
							if (convRes.addressLookupList !== undefined) {
								this.clearControlError('prefecture','都道府県を入力してください');
								this.clearControlError('address1','住所1を入力してください');
								let adrList: AddressInfo[] = convRes.addressLookupList;
								if (adrList.length > 1)
									this.setAddressListModal(adrList);
								else if (adrList.length === 1) {
									let adrInfo = adrList[0];
									this.m_Prefecture.value	= adrInfo.prefecture;
									this.m_Address1.value = this.convertToZenkaku(adrInfo.city+adrInfo.area+adrInfo.chome);
								}
								else {
									if (this.m_Prefecture.value !== null || this.m_Address1.value !== null) {
										this.m_Prefecture.value	= null;
										this.m_Address1.value 	= null;
									}
									this.setControlError('postalCode', '郵便番号が誤っています');
								}
							}
							else {
								this.m_HttpStatus = false;
							}
						}
					}
				}
			}
			this.refreshModel();
		});
	}

	/**
	 * 住所選択後処理
	 * @param prama 
	 */
	public onSelect(prama: any): void {
		this.setViewMode('selectMode','');
		this.m_Prefecture.setDisabled(false);
		this.restartBlurEvent();
		if(this.m_RadioSelect.value === ''){
			if (this.m_Prefecture.value !== null || this.m_Address1.value !== null) {
				this.m_Prefecture.value	= null;
				this.m_Address1.value 	= null;
			}
			return;
		}
		let idx = this.m_RadioSelect.value-0;
		// WRQ2083 住所検索のエラー修正 S
		// let adrInfo: AddressInfo = this.m_AddressInfoList[idx];
		let adrInfo: AddressSelectInfo = this.m_AddressSelectInfoList[idx];
		let pref:number = 0;
		if(adrInfo.prefecture.indexOf('都') !== -1)
			pref = adrInfo.prefecture.indexOf('都');
		else if(adrInfo.prefecture.indexOf('道') !== -1)
			pref = adrInfo.prefecture.indexOf('道');
		else if(adrInfo.prefecture.indexOf('府') !== -1)
			pref = adrInfo.prefecture.indexOf('府');
		else if(adrInfo.prefecture.indexOf('県') !== -1)
			pref = adrInfo.prefecture.indexOf('県');
		// this.m_Prefecture.value = adrInfo.prefecture.slice(0, pref+1);
		// this.m_Address1.value = this.convertToZenkaku(adrInfo.prefecture).slice(pref+1);
		this.m_Prefecture.value = adrInfo.prefecture;
		this.m_Address1.value = this.convertToZenkaku(adrInfo.address).slice(pref+1);
		// WRQ2083 住所検索のエラー修正 E
	}

	/**
	 * 閉じる
	 * @param param 
	 */
	public onClose(param: any): void {
		if (this.m_Prefecture.value !== null || this.m_Address1.value !== null) {
			this.m_Prefecture.value	= null;
			this.m_Address1.value 	= null;
		}
		this.setViewMode('selectMode','');
		this.m_Prefecture.setDisabled(false);
		this.restartBlurEvent();
	}

	/**
     * 反映処理
     */
	public onCopy(param: any, item: any): void {
		if (item !== null) {
			this.refreshModel();
			item.romanLastName = this.m_ContractorInfo.romanLastName;
			item.romanFirstName = this.m_ContractorInfo.romanFirstName;
			item.year = this.m_ContractorInfo.year;
			item.month = this.m_ContractorInfo.month;
			item.date = this.m_ContractorInfo.date;
			item.gender = this.m_ContractorInfo.gender;
			this.refreshView();
			this.checkListValidate('romanLastNameTraveler', item);
			this.checkListValidate('romanFirstNameTraveler', item);
			this.checkListValidate('yearTraveler', item);
			this.checkListValidate('monthTraveler', item);
			this.checkListValidate('dateTraveler', item);
			this.checkListValidate('genderTraveler', item);
		}
	}

	/**
     * 申込内容確認画面遷移処理
     */
	public onNext(param: any): void {
		this.refreshModel();	
		if (!this.m_ContractorInfo.address2)
			this.m_ContractorInfo.address2 = '';
		this.refreshView();
		this.setPolicyholderInfo();
		this.setInsuredInfo();
		// 補償表示情報リクエスト値取得
		const collateralReq = this.getCollateralReq();
		this.m_PlanByTravelWLService.getCollateralDisplay(this, collateralReq, (result) => {
			// 補償表示情報レスポンス値セット
			this.setCollateralRes(result);
			// 告知情報リクエスト値取得
			const noticeReq = this.getNoticeReq();
			this.m_ContractNoticeService.searchContractNotice(this, noticeReq, (result) => {
				// 告知情報レスポンス値セット
				this.setNoticeRes(result);
				this.pushPath('/step6_confirm');
			});
		});
		// this.refreshModel();	
		this.refreshView();
	}
	// --------------------------------------------------------------------------
	
	// privateメソッド -----------------------------------------------------------
	/**
	 * 画面用情報設定処理
	 * @param result 認証メールリダイレクトレスポンス
	 */
	private setInfoForView(result: AuthConfirmResult):void {
		this.m_SelectPlanInfo	= result.authMailInfo.selectPlanInfo;
		this.m_RiskFactorInfo	= result.authMailInfo.riskFactorInfo;
		this.m_AuthMailInfo		= result.authMailInfo;
		// 基本情報
		this.m_BasicInfo = new BasicInfo();
		const start = this.convertDate(result.authMailInfo.riskFactorInfo.startDate);
		const end 	= this.convertDate(result.authMailInfo.riskFactorInfo.endDate);
		this.m_BasicInfo.insuranceFee 		= result.authMailInfo.selectPlanInfo.totalPremium;
		this.m_BasicInfo.insurancePeriod 	= start + '～' + end;
		this.m_BasicInfo.applicationDate 	= this.convertDate(result.authMailInfo.applicationDate);
		// 旅行者（記名被保険者）情報
		let traveler: number = result.authMailInfo.riskFactorInfo.numberOfInsured;
		this.m_TravelerListInfo = [];
		// const today = new Date();
		const today = new Date(this.m_AuthMailInfo.applicationDate);
		for (let i = 0; i < traveler; i++) {
			const travelerInfo = new TravelerInfo();
			this.m_TravelerListInfo.push(travelerInfo);
			this.m_TravelerListInfo[i].year 	= (today.getFullYear() - 30).toString();
			this.m_TravelerListInfo[i].month	= '1';
			this.m_TravelerListInfo[i].date 	= '1';
		}
		// 契約者（申込者）情報
		this.m_ContractorInfo = new ContractorInfo();
		this.m_ContractorInfo.mailAddress 	= result.authMailInfo.mailAddress;
		this.m_ContractorInfo.year 			= (today.getFullYear() - 30).toString();
		this.m_ContractorInfo.month 		= '1';
		this.m_ContractorInfo.date 			= '1';
		if (result.policyContractInfo) {
			this.setContractorInfo(result.policyContractInfo.policyHolderInfo);
			this.setTravelerListInfo(result.policyContractInfo.insuredInfoList);
		}
		if (result.inquiryPw) {
			this.m_LoginInfo = new LoginInfo();
			this.m_LoginInfo.loginPass = result.inquiryPw;
			this.m_LoginInfo.loginPassAgain = result.inquiryPw;
			this.setScopeModel('LoginInfo', this.m_LoginInfo);
		}
	}

	/**
	 * 住所が複数だった場合のモーダル表示用の情報処理
	 */
	private setAddressListModal(adrList: AddressInfo[]): void {
		// WRQ2083 住所検索のエラー修正 S
		// this.m_AddressInfoList = [];
		this.m_AddressSelectInfoList = [];
		for(let key of adrList) {
			// let adrInfo: AddressInfo = new AddressInfo();
			// adrInfo.prefecture = key.prefecture+key.city+key.area+key.chome;
			// this.m_AddressInfoList.push(adrInfo);
			let adrInfo: AddressSelectInfo = new AddressSelectInfo();
			adrInfo.address = key.prefecture+key.city+key.area+key.chome;
			adrInfo.prefecture = key.prefecture;
			this.m_AddressSelectInfoList.push(adrInfo);
		}
		// this.setListData('AddressList', this.m_AddressInfoList);
		this.setListData('AddressSelectList', this.m_AddressSelectInfoList);
		// WRQ2083 住所検索のエラー修正 E
		this.setViewMode('selectMode','selectAddress');
		this.stopBlurEvent();
		this.m_Prefecture.setDisabled(true);
		this.m_RadioSelect.clearValue();
	}
	
	/**
	 * CollateralDisplayRequest値セット
	 * @param collateralReq 
	 * @param riskFactorInfo 
	 * @param paymentInfo 
	 */
	private getCollateralReq(): CollateralDisplayRequest{
		let collateralReq: CollateralDisplayRequest = new CollateralDisplayRequest();
		// const today = new Date();
		const today = new Date(this.m_AuthMailInfo.applicationDate);
		collateralReq.riskFactorInfo = this.m_RiskFactorInfo;
		collateralReq.riskFactorInfo.startDate = this.dateFormat(collateralReq.riskFactorInfo.startDate);
		collateralReq.riskFactorInfo.endDate = this.dateFormat(collateralReq.riskFactorInfo.endDate);
		collateralReq.transactionDate = this.dateToString(today);
		collateralReq.planCode = this.m_SelectPlanInfo.planCode;
		collateralReq.paymentInfo = new PaymentInfo();
		collateralReq.policyContractInfo = new PolicyContractInfo();
		collateralReq.policyContractInfo.policyHolderInfo = this.m_PolicyHolderInfo;
		collateralReq.policyContractInfo.insuredInfoList = this.m_InsuredInfoList;
		collateralReq.inquiryPw = this.m_LoginInfo.loginPass;
		return collateralReq;
	}

	/**
	 * CollateralDisplayResult値取得
	 * @param collateralRes 
	 */
	private setCollateralRes(collateralRes: CollateralDisplayResult) {
		let collateralDisplaySize: number = collateralRes.collateralDisplayInfoList.length;
		this.m_Collaterals = [];
		const colDispList = collateralRes.collateralDisplayInfoList.sort((n1, n2) => {
			if (n1.orderNo > n2.orderNo)
				return 1;
			if (n1.orderNo < n2.orderNo)
				return -1;
			return 0;
		});
		for (let i = 0; i < collateralDisplaySize; i++) {
			let collateral = new CollateralInfo();
			collateral.collateralKey 			= colDispList[i].collateralKey;
			collateral.collateralDescription 	= colDispList[i].collateralDescription;
			if (collateral.collateralKey === this.EXTRA_COLLKEY_OTA) 
				collateral.collateralDescription = this.insertBr(collateral.collateralDescription);
			collateral.displayCollateralName 	= colDispList[i].displayCollateralName;
			collateral.collateralName 			= colDispList[i].collateralShortName;
			// collateral.collateralAmount 		= collateralRes.coverages[i].coverageAmount;
			collateral.collateralAmount 		= colDispList[i].coverageAmount;
			this.m_Collaterals.push(collateral);
		} 
		this.setScopeModel('CollateralInfo', this.m_Collaterals);
		this.setListData('CollateralInfo', this.m_Collaterals);
		this.m_SpecialProvision.specialProvision = collateralRes.specialProvision;
		this.setScopeModel('SpecialProvision', this.m_SpecialProvision);
		this.m_BasicInfo.plan = collateralRes.planName;
		if (this.m_SelectPlanInfo.addExtraCoverageFlg === '1')
			this.m_BasicInfo.plan += ' + オプション'; 
	}

	/**
	 * ContractNoticeRequest値取得
	 * @param noticeReq
	 */
	private getNoticeReq(): ContractNoticeRequest{
		let noticeReq: ContractNoticeRequest = new ContractNoticeRequest();
		noticeReq.planCode 				= this.m_SelectPlanInfo.planCode;
		noticeReq.companyProductCode 	= this.m_RiskFactorInfo.companyProductCode;
		noticeReq.agentCode 			= this.m_Agency;
		return noticeReq;
	}

	/**
	 * ContractNoticeResult値セット
	 * @param noticeRes
	 */
	private setNoticeRes(noticeRes: ContractNoticeResult) {
		let NoticeSize: number = noticeRes.contractNoticeInfoList.length;
		this.m_ContractNoticeList = [];
		for (let i = 0; i < NoticeSize; i++) {
			let contractNotice = new ContractNoticeInfo();
			contractNotice = noticeRes.contractNoticeInfoList[i];
			this.m_ContractNoticeList.push(contractNotice);
		}
		this.setScopeModel('ContractNoticeInfo', this.m_ContractNoticeList);
		this.setListData('ContractNoticeInfo', this.m_ContractNoticeList);
		this.m_OthersInfo = new OthersInfo();
		this.m_OthersInfo.url		= noticeRes.importantCertificateUrl;
		this.m_OthersInfo.agency 	= noticeRes.agentName;
		this.setScopeModel('OthersInfo', this.m_OthersInfo);
	}

	/**
	 * PolicyholderInfoセット（締結サービスリクエスト用）
	 */
	private setPolicyholderInfo(): void{
		this.m_PolicyHolderInfo = new PolicyHolderInfo();
		this.m_PolicyHolderInfo.surName 		= this.m_ContractorInfo.lastName;
		this.m_PolicyHolderInfo.surNameKana 	= this.m_ContractorInfo.romanLastName;
		this.m_PolicyHolderInfo.firstName 		= this.m_ContractorInfo.firstName;
		this.m_PolicyHolderInfo.firstNameKana 	= this.m_ContractorInfo.romanFirstName;
		this.m_PolicyHolderInfo.dateOfBirth 	= this.m_ContractorInfo.year + '/' + this.m_ContractorInfo.month + '/' + this.m_ContractorInfo.date;
		this.m_PolicyHolderInfo.gender 			= this.m_ContractorInfo.gender;
		this.m_PolicyHolderInfo.postCode 		= this.m_ContractorInfo.postalCode;
		this.m_PolicyHolderInfo.prefecture 		= this.m_ContractorInfo.prefecture;
		this.m_PolicyHolderInfo.address1 		= this.m_ContractorInfo.address1;
		this.m_PolicyHolderInfo.address2 		= this.m_ContractorInfo.address2;
		this.m_PolicyHolderInfo.phoneNumber 	= this.m_ContractorInfo.tel;
		this.m_PolicyHolderInfo.mailAddress 	= this.m_ContractorInfo.mailAddress;
		this.refreshModel();
		this.setScopeModel('PolicyHolderInfo', this.m_PolicyHolderInfo);
	}

	private setContractorInfo(policyHolderInfo: PolicyHolderInfo): void {
		this.m_ContractorInfo = new ContractorInfo();
		this.m_ContractorInfo.lastName = policyHolderInfo.surName;
		this.m_ContractorInfo.romanLastName = policyHolderInfo.surNameKana;
		this.m_ContractorInfo.firstName = policyHolderInfo.firstName;
		this.m_ContractorInfo.romanFirstName = policyHolderInfo.firstNameKana;
		const dateOfBirth: Date = new Date(Date.parse(policyHolderInfo.dateOfBirth));
		this.m_ContractorInfo.year = dateOfBirth.getFullYear().toString();
		this.m_ContractorInfo.month = (dateOfBirth.getMonth() + 1).toString();
		this.m_ContractorInfo.date = dateOfBirth.getDay().toString();
		this.m_ContractorInfo.gender = policyHolderInfo.gender;
		this.m_ContractorInfo.postalCode = policyHolderInfo.postCode;
		this.m_ContractorInfo.prefecture = policyHolderInfo.prefecture;
		this.m_ContractorInfo.address1 = policyHolderInfo.address1;
		this.m_ContractorInfo.address2 = policyHolderInfo.address2;
		this.m_ContractorInfo.tel = policyHolderInfo.phoneNumber;
		this.m_ContractorInfo.mailAddress = policyHolderInfo.mailAddress;
	}

	/**
	 * InsuredInfoセット（締結サービスリクエスト用）
	 */
	private setInsuredInfo(): void {
		this.m_InsuredInfoList = [];
		for (let info of this.m_TravelerListInfo){
			const insuredInfo = new InsuredInfo();
			insuredInfo.surNameKana		= info.romanLastName;
			insuredInfo.firstNameKana 	= info.romanFirstName;
			insuredInfo.dateOfBirth 	= info.year + '/' + info.month + '/' + info.date;
			insuredInfo.gender 			= info.gender;
			this.m_InsuredInfoList.push(insuredInfo);
		}
		this.refreshModel();
		this.setScopeModel('InsuredInfoList', this.m_InsuredInfoList);
	}

	private setTravelerListInfo(insuredInfoList: InsuredInfo[]): void {
		this.m_TravelerListInfo = [];
		for (let insuredInfo of insuredInfoList) {
			const travelerInfo: TravelerInfo = new TravelerInfo();
			travelerInfo.romanLastName = insuredInfo.surNameKana;
			travelerInfo.romanFirstName = insuredInfo.firstNameKana;
			const dateOfBirth: Date = new Date(Date.parse(insuredInfo.dateOfBirth));
			travelerInfo.year = dateOfBirth.getFullYear().toString();
			travelerInfo.month = (dateOfBirth.getMonth() + 1).toString();
			travelerInfo.date = dateOfBirth.getDay().toString();
			travelerInfo.gender = insuredInfo.gender;
			this.m_TravelerListInfo.push(travelerInfo);
		}
	}

	/**
	 * スクロール処理
	 */
	public scroll(): void {
		if (this.m_ScrollPositionInfo.id) {
			const scrollPosition = document.getElementById(this.m_ScrollPositionInfo.id);
			window.scrollTo(0, scrollPosition.offsetTop);
			this.m_ScrollPositionInfo.id = null;
		}
		else {
			super.scroll();
		}
	}

	/**
	 * 年齢計算
	 * 日付1は基準となる日（TODAYなど）、日付2は生年月日
	 * @param year1 
	 * @param month1 
	 * @param date1 
	 * @param year2 
	 * @param month2 
	 * @param date2 
	 * @returns 日付1時点での年齢
	 */
	private calculateAge(year1: any, month1: any, date1: any, year2: any, month2: any, date2: any): number {
		const y1 = Number(year1) * 10000;
		const m1 = Number(month1) * 100;
		const d1 = Number(date1);
		const y2 = Number(year2) * 10000;
		const m2 = Number(month2) * 100;
		const d2 = Number(date2);
		const age = Math.floor(((y1 + m1 + d1) - (y2 + m2 + d2)) / 10000);
		return age;
	}

	/**
	 * 生年月日バリューマップ変更
	 * @returns 再設定したKey-Valueリスト
	 */
	private changeDateValueMap(yearValue: number, monthValue: number, list: WprKeyValue[]): WprKeyValue[] {
		// let today = new Date();
		let today = new Date(this.m_AuthMailInfo.applicationDate);
		let thisYear = today.getFullYear();
		if (yearValue)
			thisYear = yearValue;
		let thisMonth = today.getMonth() + 1;
		if (monthValue)
			thisMonth = monthValue;
		let isLeapYear = (year: number) => (year % 4 === 0) && (year % 100 !== 0) || (year % 400 === 0);
		let datesOfFebruary = isLeapYear(thisYear) ? 29 : 28;
		let datesOfYear = [31, datesOfFebruary, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
		const newList = new Array();
		for (let i = 0; i < datesOfYear[thisMonth - 1]; i++) {
			newList.push(list[i]);
		}
		return newList;
	}
	
	/**
	 * 日付値クリア処理
	 */
	private onClearValue() {
		this.m_ClearValueControl.clearValue();
	}

	/**
	 *  Date型 → string型変換処理
	 * @returns 例： '2020-01-01 15:00:00+0900'
	 */
	private dateToString(date: Date): string {
		let year 	= date.getFullYear();
		let month 	= ('00' + (date.getMonth() + 1)).slice(-2);
		let day 	= ('00' + date.getDate()).slice(-2);
		let hour 	= ('00' + date.getHours()).slice(-2);
		let minute 	= ('00' + date.getMinutes()).slice(-2);
		let second 	= ('00' + date.getSeconds()).slice(-2);
		return `${year}-${month}-${day} ${hour}:${minute}:${second}+0900`;
	}

	/**
	 * 日付「YYYY/MM/dd」を「YYYY年MM月dd日」に変換
	 * 　例：2020/04/31　→　2020年4月31日
	 * @param date 
	 */
	private convertDate(date: string): string {
		return date.replace(/\/0/g, '/').replace(/(\d+)\/(\d+)\/(\d+)/g , '$1年$2月$3日' );
	}

	/**
	 * 日付「YYYY/MM/DD」を「YYYY-MM-DD」に変換
	 * @param date 
	 */
	private dateFormat(date: string): string {
		return date.replace(/(\d+)\/(\d+)\/(\d+)/g, '$1-$2-$3');
	}

	/**
	 * 日付を「-」「/」「 」で分割する
	 * @param date 
	 */
	private splitDate(date: string): string[] {
		let splited = date.split(/-|\/|\s/);
		return splited;
	}

	/**
	 * 半角文字を全角文字に変換
	 * @param value 
	 */
	private convertToZenkaku(value: string): string {
		// WRQ2084 環境依存ハイフンを全部半角ハイフンに S
		// 環境依存ハイフンを全部半角ハイフンに S
		//let str = value.replace(/[—⁻₋ｰ∸∹∺⊖⊝⊟⊶⊷⊸⋯]/g, '-');
		// WRQ-2403 ハイフン置換対象追加
		 let str = value.replace(/[-－﹣‐­⁃­‑⁻∸∹∺⊖⊝⊟⊶⊷⊸⋯−˗➖₋゠̠∓∖‒–—﹘⸺⸻―⎯⏤─━╴╶╸╺╼╾ーｰ¯ˉ￣ˍ一⼀㆒㇐_＿‾▁▂▃▄▅▆▇█▔▬]/g, '-');
		// WRQ2084 環境依存ハイフンを全部半角ハイフンに E
		str = str.replace(/ /g, '　');
		// WRQ-4426_【旅行保険】CLT-MOD（顧客番号欠番）の影響調査および恒久対応（追加対応） START
		//環境依存文字などを補正
		str = str.replace('〜', '－');
		str = str.replace('•', '・');
		str = str.replace(' ', '　');
		// WRQ-4426_【旅行保険】CLT-MOD（顧客番号欠番）の影響調査および恒久対応（追加対応） END
		return str.replace(/[ -~]/g, function (match) {
			return String.fromCharCode(match.charCodeAt(0) + 0xFEE0);
		});
	}

	/**
	 * brタグ挿入
	 */
	private insertBr(collDesc: string): string {
		if (collDesc.includes('<br />') === false) {
			const st = collDesc.slice(0,31);
			const br = '<br />';
			const en = collDesc.slice(31);
			return st+br+en;
		}
		return collDesc;
	}
	// --------------------------------------------------------------------------
}
